/**
 * War Room uses a shared queryClient from app root.
 * Query keys follow format: ['war-room', entity, ...params]
 */
export const WAR_ROOM_QUERY_KEYS = {
  sessions:        (workspaceId: string)                => ['war-room', 'sessions', workspaceId],
  session:         (sessionId: string)                  => ['war-room', 'session', sessionId],
  teams:           (sessionId: string)                  => ['war-room', 'teams', sessionId],
  steps:           (sessionId: string)                  => ['war-room', 'steps', sessionId],
  stepsByTeam:     (sessionId: string, teamId: string)  => ['war-room', 'steps', sessionId, teamId],
  preflight:       (sessionId: string)                  => ['war-room', 'preflight', sessionId],
  graph:           (sessionId: string)                  => ['war-room', 'graph', sessionId],
  history:         (workspaceId: string)                => ['war-room', 'history', workspaceId],
  executionRecord: (sessionId: string)                  => ['war-room', 'record', sessionId],
} as const
